<template>
  <div class="re-carousel" ref="carouselWrap">
    <swiper
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      :space-between="50"
      loop
      :autoplay="{ autoplay: true }"
      :pagination="{ clickable: true }"
    >
      <swiper-slide v-for="item of activedCarousel" :key="item.id">
        <div class="carouesel-wrapper">
          <div class="carousel-box" ref="carouselBox">
            <div
              v-if="showImg"
              :style="{
                borderRadius: `${rounded}px`,
              }"
              class="carousel-box__img-box"
            >
              <img class="carousel-box__img-box__img" :src="item.imgPath" />
            </div>

            <template v-if="item.renderContent">
              <component :is="item.renderContent" :data="item.data" />
            </template>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { debounce } from 'lodash-es';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import SwiperCore, { Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/modules/pagination/pagination.min.css';

SwiperCore.use([Pagination, Autoplay]);

export default defineComponent({
  name: 'ReCarousel',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    carouselList: {
      type: Array,
      default: () => [],
    },
    showImg: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: String,
      default: '0',
    },
  },
  setup() {
    // const carouselSwiper = ref(null);
    const onSwiper = () => {
      // console.log(swiper.activeIndex);
    };
    const onSlideChange = () => {
      // console.log('slide change');
    };

    // const activeIndex = computed(() => {
    //   if (carouselSwiper.value) {
    //     return carouselSwiper.value.swiper;
    //   }

    //   return 0;
    // });

    // const pagination = {

    //   clickable: true,
    //   renderBullet(index, className) {
    //     return `<span class="${className}">${index + 1}</span>`;
    //   },
    // };

    return {
      onSwiper,
      onSlideChange,
      // carouselSwiper,
      // activeIndex,
      // pagination,
    };
  },
  data() {
    return {
      activedCarousel: [],
      transformOffset: 0,
      currIndex: 0,
      timer: null,
      withTransition: true,
      disabled: false,
      transitionTimer: null,
      carouselWidth: 0,
      startTouch: {},
    };
  },
  methods: {
    changeActivedCarousel() {
      if (this.currIndex === 0) {
        this.activedCarousel = [
          this.carouselList[this.carouselList.length - 1],
          this.carouselList[this.currIndex],
          this.carouselList[this.currIndex + 1],
        ];

        return;
      }

      if (this.currIndex === this.carouselList.length - 1) {
        this.activedCarousel = [
          this.carouselList[this.currIndex - 1],
          this.carouselList[this.currIndex],
          this.carouselList[0],
        ];

        return;
      }

      this.activedCarousel = [
        this.carouselList[this.currIndex - 1],
        this.carouselList[this.currIndex],
        this.carouselList[this.currIndex + 1],
      ];
    },
    setTransformOffset() {
      this.withTransition = true;
      this.transformOffset = this.carouselWidth * 2;

      this.transitionTimer = setTimeout(() => {
        this.withTransition = false;
        this.changeActivedCarousel();
        this.transformOffset = this.carouselWidth;
      }, 400);
    },
    calcCarouselWidth() {
      const w = this.$refs.carouselWrap.clientWidth;

      this.carouselWidth = w;
    },

    // eslint-disable-next-line
    calcCaourselWidthDebounce: debounce(function () {
      this.calcCarouselWidth();
    }, 100),
  },
  created() {
    this.changeActivedCarousel();
  },
  mounted() {
    this.calcCarouselWidth();
    window.addEventListener('resize', this.calcCaourselWidthDebounce);
  },
});
</script>

<style lang="scss" scoped>
.carouesel-wrapper {
  margin: 30px 0;
  width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  position: relative;
}

.carousel-box {
  width: 100%;
  height: auto;
  position: relative;
  overflow-x: hidden;

  &--with-transition {
    transition: 0.4s;
  }

  &__img-box {
    display: inline-block;
    vertical-align: bottom;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;

    &__img {
      width: 100%;
    }
  }
}

</style>

<style lang="scss">
.re-carousel {
  .swiper {
    padding-bottom: 30px;
  }
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin-left: 10px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .swiper-pagination-bullet-active {
    background-color: #f9db4a;
  }
}
</style>
